var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-dark export-button",attrs:{"type":"button","disabled":_vm.disabled,"title":"Export to CSV"},on:{"click":_vm.onClick}},[_c('i',{staticClass:"fa fa-file-excel-o"}),_vm._v("\n  Export CSV\n")])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-062652fb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CSV.vue
// module id = 704
// module chunks = 1